export default __webpack_public_path__ + "7d93b8394f9d73e13101955ab93bc6fe.svg";